import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withCookies } from 'react-cookie'
import i18n from 'cityads-v3/i18n';
import classNames from 'classnames'

import { Link } from 'react-router-dom'
import Button from '@material-ui/core/Button';


import classes from './HomeBanner.scss';

import videoBack from './videoBack.mp4';
import videoBackWebm from './videoBack.webm';
import poster from './videoBack.jpg';

@withCookies
@withTranslation(['main'], { i18n, wait: !!window })
export default class Banner extends Component {
  static propTypes = {
    show: PropTypes.bool
  };

  state = {
    show: this.props.show || true,
    videoNum: 0
  }

  UNSAFE_componentWillReceiveProps (props) {
    if (props.hasOwnProperty('show')) {
      this.setState({
        show: props.show
      });
    }
  }

  componentDidMount() {
    // if (document) {
    //   this.eventPlayVideo = document.getElementsByTagName('html')[0].addEventListener('click', () => this.playVideo());
    // }
  }

  componentWillUnmount() {
    // document.getElementsByTagName('html')[0].removeEventListener('click', this.eventPlayVideo);
  }

  playVideo() {
    this.refs.video.play();
  }

  render () {
    const { t, cookies } = this.props;
    const isIos = navigator && !!navigator.platform && /iPhone|iPod/.test(navigator.platform)
    const showVideo = !isIos;
    const year = (new Date()).getFullYear();
    const FEATURE_BLOGGER_REGISTRATION = !!cookies?.cookies?.FEATURE_BLOGGER_REGISTRATION;

    return (
      <div className={this.state.show ? classes.homeBanner : classes.homeBannerHide}>
        {showVideo && (
          <video ref="video" preload="auto" poster={poster} autoPlay={true} loop={true} muted={true} playsInline={true} className={classes.videoBack}>
            <source src={videoBack} />
            <source src={videoBackWebm} />
          </video>
        )}
        <div className={classes.videoBackFlow} />
        <div className={classes.content}>
          <div className={classes.wrapper}>
            <div className={classes.years}>2011—{year}</div>

            <h1 className={classes.title}>
              {t('banner.title')}
            </h1>

            <div className={classNames(classes.columns, {
              [classes.triple]: FEATURE_BLOGGER_REGISTRATION
            })}>
              {FEATURE_BLOGGER_REGISTRATION ? (
                <div className={classes.column}>
                  <div className={classes.columnContent} dangerouslySetInnerHTML={{ __html: t('banner.blogger') }} />

                  <Button variant="contained" color="primary" component={Link} to={'/main/register/blogger'}>
                    {t('banner.blogger_button')}
                  </Button>
                </div>
              ) : null}

              <div className={classes.column}>
                <div className={classes.columnContent} dangerouslySetInnerHTML={{ __html: t('banner.advertiser') }} />

                <Button variant="contained" color="primary" component={Link} to={'/main/advertiser'}>
                  {t('banner.advertiser_button')}
                </Button>
              </div>

              <div className={classes.column}>
                <div className={classes.columnContent} dangerouslySetInnerHTML={{ __html: t('banner.publisher') }} />

                <Button variant="contained" color="primary" component={Link} to={'/main/publisher'}>
                  {t('banner.publisher_button')}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
